import { fetchToken } from "../../../common/FetchCookie"
import { BASE_URL, CANDIDATE, CAREER_ADVICE_CANDIDATE } from "../../../common/URLs";

export const fetchCareerAdvice = async () => {
    const token = await fetchToken();
    try {
        const url = `${BASE_URL}/${CANDIDATE}/${CAREER_ADVICE_CANDIDATE}`; // Proxy path
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return data.response;
    } catch (error) {
        console.log("error", error);
    }
}